import { ListBooking } from 'types';
import { ItemLinkProps } from '../../../Components/ItemLinks/ItemLink';
import { scheduledPaymentUpdateCreditCardLinkSelected } from 'lib/gaTracking/crossPageEvents';
import UpdateCreditCardAlert from '../../UpdateCreditCardAlert';
import shouldUpdatePaymentMethod from 'pages/BookingListPage/utils/shouldUpdatePaymentMethod';
import { getUpdatePaymentMethodPageLink } from 'lib/links';

export const generateUpdatePaymentMethodItemLink = (booking: ListBooking): ItemLinkProps | null => {
  const {
    flags: { isFinalising, isChangeInProgress },
  } = booking;
  const isPaymentMethodUpdateRequire = shouldUpdatePaymentMethod(booking);

  if (isFinalising || isChangeInProgress || !isPaymentMethodUpdateRequire) {
    return null;
  }

  const updatePaymentMethodItemLink = {
    label: 'Update credit card',
    url: getUpdatePaymentMethodPageLink(booking.id),
    onClick: scheduledPaymentUpdateCreditCardLinkSelected,
    'data-testid': 'update-payment-method-link',
    alert: <UpdateCreditCardAlert />,
  };

  return updatePaymentMethodItemLink;
};
